module.exports = __webpack_public_path__ + "fonts/RobotoMono-MediumItalic.30ed59c4.woff2";